export default __webpack_public_path__ + "static/media/country.e9cbc9e9.jpg";